import { TextField } from '@mui/material';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import usePlanStore from '../../../../../../store/planStore';
import useCheckPlanName from './hooks/useCheckPlanName';
import { CheckPlanNameError } from '../../../../../../api/services/mediaPlanning/checkPlanName';

export default function CampaignNameInput() {
  const { t } = useTranslation();
  const { generalInfoState, setGeneralInfoState, savedGeneralInfoState } =
    usePlanStore((state) => ({
      generalInfoState: state.generalInfoState,
      savedGeneralInfoState: state.savedGeneralInfoState,
      setGeneralInfoState: state.setGeneralInfoState,
    }));

  const { id } = useParams();

  const { error } = useCheckPlanName();

  const errorData = error as unknown as CheckPlanNameError | undefined;
  const errorStatus = errorData?.data?.status;

  const { campaignName } = generalInfoState;
  const isDuplicateError =
    campaignName !== savedGeneralInfoState?.campaignName &&
    errorStatus === 'fail';

  const isTooLong = campaignName.length > 120;
  const isInvalidFormat =
    campaignName.length > 0 &&
    !/^[A-Za-z0-9_-]+(?:[ ][A-Za-z0-9_-]+)*$/.test(campaignName);

  let campaignHelperText = '';

  if (isInvalidFormat || isTooLong) {
    campaignHelperText = t(
      'You cannot use characters other than letters, numbers, hyphens and underscores or exceed 120 characters'
    );
  } else if (isDuplicateError) {
    campaignHelperText = t('mediaPlanning.errors.duplicatedCampaignName');
  }

  return (
    <Controller
      name="campaignName"
      render={({ field }) => (
        <TextField
          {...field}
          label={t('Campaign Name')}
          variant="outlined"
          value={generalInfoState.campaignName}
          fullWidth
          error={
            (generalInfoState.campaignName !==
              savedGeneralInfoState?.campaignName &&
              errorStatus === 'fail') ||
            isInvalidFormat ||
            generalInfoState.campaignName.length > 120
          }
          helperText={campaignHelperText}
          onChange={(event) => {
            setGeneralInfoState({
              campaignName: event.target.value,
            });
          }}
          disabled={!!id}
        />
      )}
    />
  );
}
